import * as angular from 'angular';

import { IDispatcherService, IDispatcher } from '..';
import { Workspace } from '../../models';
import { IAuthentication, ILoginData, ILoginResult } from '../../services';
import { IAuthenticationActionsService } from './authentication.actionCreator';

export interface IAuthenticationStoreService {
    connect(userName: string, workspace: Workspace, applicationGuid: string, showToast: boolean): angular.IPromise<void>;
    connectByApplicationName(applicationName: string, applicationGuid: string): angular.IPromise<any>;
    connectByWorkspace(userName: string, workspace: Workspace): angular.IPromise<any>;
    disconnect(): angular.IPromise<void>;
    fillAuthData(): angular.IPromise<Readonly<IAuthentication>>;
    login(loginData, logoutOnFail?: boolean): angular.IPromise<ILoginResult>;
    logout(): angular.IPromise<void>;
    updateUserData(values: { datePickerFormat?: string }): angular.IPromise<void>;
}

export interface IAuthenticationActionsDispatcherService extends IDispatcherService<IAuthenticationStoreService> { }

export class AuthenticationActionsDispatcherService implements IAuthenticationActionsDispatcherService {
    static serviceId = 'authenticationActionsDispatcherService';

    static $inject = ['authenticationActionsService'];

    constructor(private _actionService: IAuthenticationActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IAuthenticationStoreService> {
        const service = this._actionService;

        return {
            dispatcher: {
                connect: (userName: string, workspace: Workspace, applicationGuid: string, showToast: boolean) => dispatch(service.connect(userName, workspace, applicationGuid, showToast)),
                connectByApplicationName: (appName: string, appGuid: string) => dispatch(service.connectByApplicationName(appName, appGuid)),
                connectByWorkspace: (userName: string, workspace: Workspace) => dispatch(service.connectByWorkspace(userName, workspace)),
                disconnect: () => dispatch(service.disconnect()),
                fillAuthData: () => dispatch(service.fillAuthData()),
                login: (loginData: ILoginData, logoutOnFail?: boolean) => dispatch(service.login(loginData, logoutOnFail)),
                logout: () => dispatch(service.logout()),
                updateUserData: (values: { datePickerFormat?: string }) => dispatch(service.updateUserData(values)),
            }
        };
    }
}